import { Check } from 'lucide-react';

export const ItemSelectedIcon = () => {
  return (
    <Check className="absolute top-1/2 transform -translate-y-1/2 right-1 flex size-3" />
  );
};

